import { useCallback, useState } from 'react'
import { getSession, register, login, clearSession, type Session } from './atlasAuth'

const MIN_PASSWORD = 8

export interface AuthState {
  session: Session | null
  pending: boolean
  error: string | null
}

/** Real registration/login against Atlas — see atlasAuth.ts for why this is genuine, not mocked. */
export function useAuth() {
  const [state, setState] = useState<AuthState>({ session: getSession(), pending: false, error: null })

  const submit = useCallback(async (mode: 'register' | 'login', email: string, password: string) => {
    if (!email.trim() || password.length < MIN_PASSWORD) {
      setState((s) => ({ ...s, error: `Password must be at least ${MIN_PASSWORD} characters.` }))
      return
    }
    setState((s) => ({ ...s, pending: true, error: null }))
    const result = mode === 'register' ? await register(email.trim(), password) : await login(email.trim(), password)
    if (!result.ok) {
      setState({ session: null, pending: false, error: result.error })
      return
    }
    setState({ session: result.session, pending: false, error: null })
  }, [])

  const signOut = useCallback(() => {
    clearSession()
    setState({ session: null, pending: false, error: null })
  }, [])

  return { ...state, submit, signOut }
}
